import classNames from "classnames";
import { get } from "lodash";
import { CURRENCY_SYMBOL } from "utils/constants";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Layout from "../Components/Layout";

const formatCost = (cost) => Number(cost || 0).toFixed(2);

const View = ({
  combinations,
  selectedCombinationId,
  onSelect,
  onNext,
  onBack,
  loading,
}) => {
  return (
    <Layout>
      <Header
        title="Choisissez la <b>formule</b> que vous souhaitez souscrire"
        highlight="formule"
        subtitle="Votre choix final"
        onBack={onBack}
      />
      <div className="mobilityMutual-upsells-info">
        Plusieurs combinaisons vous ont été proposées dans le devis.
        Sélectionnez celle que vous souhaitez souscrire.
      </div>
      <div className="select-combination__list">
        {combinations.map((combination) => {
          const symbol = CURRENCY_SYMBOL[combination.currency] || "";
          const isSelected = selectedCombinationId === combination.id;
          return (
            <div
              key={combination.id}
              className={classNames("select-combination__card", {
                "select-combination__card--selected": isSelected,
              })}
              onClick={() => onSelect(combination.id)}
            >
              <div className="select-combination__card--header">
                <div className="select-combination__card--name">
                  {combination.label}
                </div>
                <div className="select-combination__card--price">
                  {formatCost(combination.totalCost)} {symbol}
                  <span className="select-combination__card--period">
                    {" "}
                    / mois
                  </span>
                </div>
              </div>
              <div className="select-combination__card--detail">
                <div>
                  <span>{get(combination, "baseInsurancePlan.name", "—")}</span>
                  <span>
                    {formatCost(combination.baseCost)} {symbol}
                  </span>
                </div>
                {combination.complementaryInsurancePlan && (
                  <div>
                    <span>
                      {get(
                        combination,
                        "complementaryInsurancePlan.name",
                        "—",
                      )}
                    </span>
                    <span>
                      {formatCost(combination.complementCost)} {symbol}
                    </span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <ActionButtons
        buttonText={"Je souscris à cette formule"}
        onNext={onNext}
        onBack={onBack}
        disabled={!selectedCombinationId || loading}
        loading={loading}
      />
    </Layout>
  );
};

export default View;
